import * as types from './mutationTypes';

export const login = ({ commit }, payload) => {
  commit(types.LOGIN, payload);
};

export const check = ({ commit }, payload) => {
  commit(types.CHECK, payload);
};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
};

export const refresh = ({ commit }, payload) => {
  commit(types.REFRESH, payload);
};

export const resetState = ({ commit }, payload) => {
  commit(types.RESET_STATE, payload);
};

export default {
  login,
  check,
  logout,
  refresh,
  resetState,
};
